module.exports = __webpack_public_path__ + "static/media/Missing_avatar.315cf354.png";